import FormPostal from "../pages/BookingForm/FormPostal";
import AuthLayout from "../layouts/AuthLayout";
import UserLayout from "../layouts/UserLayout";
import ForgotPassword from "../pages/auth/ForgotPassword";
import Login from "../pages/auth/Login";
import SignUp from "../pages/auth/SignUp";
import VerifyOtp from "../pages/auth/VerifyOtp";
import PasswordReset from "../pages/auth/PasswordReset";
import CheckOut from "../pages/CheckOut";
import Professional from "../pages/BookingForm/Professional";
import MyProfile from "../pages/Customer/MyProfile/MyProfile";
import Dashboard from "../pages/Customer/Dashboard/Dashboard";
import Booking from "../pages/Customer/MyBookings/Booking";
import BookingDetails from "../pages/Customer/MyBookings/BookingDetails";
import Orders from "../pages/Customer/MyOrders/Orders";
import OrderDetails from "../pages/Customer/MyOrders/OrderDetails";
import NoContentPage from "../components/common/NoContentPage";
import OrderPending from "../pages/Customer/MyOrders/OrderPending";
import OrderBookingMainPage from "../pages/BookingForm/GeneralRegularBooking/OrderBookingMainPage";
import Review from "../pages/Customer/ReviewRating/Review";
import ThankYouPageReview from "../pages/Customer/ReviewRating/ThankYouPageReview";
import OrderThankYou from "../pages/Customer/MyOrders/OrderThankYou";
import CMSVerifier from "../pages/BookingForm/CMSVerifier/CMSVerifier";
import { lazy } from "react";

const LandingPage = lazy(() =>
  import("../components/common/LandingPage/LandingPage")
);

// import GeneralAnnotaion from "../pages/BookingForm/GeneralAnnotaion";
/**
 * *Import component and create a route by define a path.
 *
 */
const AuthLayoutFunc = (comp) => {
  return <AuthLayout>{comp}</AuthLayout>;
};
const UserLayoutFunc = (comp) => {
  return <UserLayout>{comp}</UserLayout>;
};
const routes = [
  // auth routes
  {
    path: "/login",
    element: AuthLayoutFunc(<Login />),
    // protected: false,
    type: "auth",
    role: [],
    // isFooter:false,
  },
  {
    path: "/signup",
    element: AuthLayoutFunc(<SignUp />),
    // protected: false,
    type: "auth",
    role: [],
    // isFooter:true,
  },
  {
    path: "/forgot-password",
    element: AuthLayoutFunc(<ForgotPassword />),
    // protected: false,
    type: "auth",
    role: [],
  },
  {
    path: "/Verify-otp",
    element: AuthLayoutFunc(<VerifyOtp />),
    // protected: false,
    type: "auth",
    role: [],
  },
  {
    path: "/cms-verifier",
    element: AuthLayoutFunc(<CMSVerifier />),
    // protected: false,
    type: "auth",
    role: [],
  },
  {
    path: "/reset-password",
    element: AuthLayoutFunc(<PasswordReset />),
    // protected: false,
    type: "auth",
    role: [],
  },

  // user routes
  {
    path: "/",
    element: AuthLayoutFunc(<LandingPage />),
    // protected: false,
    type: "auth",
    role: [],
  },

  {
    path: "/formpostal",
    element: AuthLayoutFunc(<FormPostal />),
    // protected: false,
    // type: "auth",
    role: [],
  },
  {
    path: "/order-booking",
    element: AuthLayoutFunc(<OrderBookingMainPage />),
    // protected: false,
    // type: "auth",
    role: [],
  },

  {
    path: "/checkout",
    element: AuthLayoutFunc(<CheckOut />),
    // protected: false,
    type: "non-protected",
    role: [],
  },
  {
    path: "/professional",
    element: AuthLayoutFunc(<Professional />),
    // protected: false,
    // type: "auth",
    role: [],
  },
  {
    path: "/dashboard",
    element: UserLayoutFunc(<Dashboard />),
    // protected: true,
    type: "protected",
    role: ["customer"],
  },
  {
    path: "/booking",
    element: UserLayoutFunc(<Booking />),
    // protected: true,
    type: "protected",
    role: ["customer"],
  },
  {
    path: "/booking-details/:id",
    element: UserLayoutFunc(<BookingDetails />),
    // protected: true,
    type: "protected",
    role: ["customer"],
  },
  {
    path: "/my-orders",
    element: UserLayoutFunc(<Orders />),
    // protected: true,
    type: "protected",
    role: ["customer"],
  },
  {
    path: "/order-details/:id",
    element: UserLayoutFunc(<OrderDetails />),
    // protected: true,
    type: "non-protected",
    role: ["customer"],
  },
  {
    path: "/order-thank-you",
    element: UserLayoutFunc(<OrderThankYou />),
    // protected: true,
    type: "protected",
    role: ["customer"],
  },
  {
    path: "/orderPending",
    element: UserLayoutFunc(<OrderPending />),
    // protected: true,
    type: "protected",
    role: ["customer"],
  },

  {
    path: "/my-profile",
    element: UserLayoutFunc(<MyProfile />),
    // protected: true,
    type: "protected",
    role: ["customer"],
  },
  {
    path: "/review/:id",
    element: UserLayoutFunc(<Review />),
    // protected: true,
    type: "non-protected",
    role: ["customer"],
  },
  {
    path: "/review/thank-you",
    element: UserLayoutFunc(<ThankYouPageReview />),
    // protected: true,
    type: "protected",
    role: ["customer"],
  },

  {
    path: "*",
    element: <NoContentPage />,
  },
];

export default routes;
